import { baseApi } from "@/store/baseApi";

// Re-pricing goes through the app's route handler because neo needs the shopper's delivery zip, which only the
// server resolves (from cookies, the primary address, or the shopper's location).
export const sellerOptionsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSellerOptions: builder.query<VendorOptionState[], SellerOptionsRequest>({
      queryFn: async ({ mpId, quantity, isManufacturerSponsor }, _api, _extraOptions, baseQuery) => {
        const result = await baseQuery({
          url: "next/seller-options",
          params: { mpId, quantity, isManufacturerSponsor },
        });
        if (result.error) {
          return { error: result.error };
        }
        // A product the page offered can't lose every offer, so an empty list means neo couldn't be reached.
        const offers = result.data as VendorOptionState[];
        return offers.length > 0 ? { data: offers } : { error: { status: "CUSTOM_ERROR", error: "No seller options" } };
      },
    }),
  }),
});

export const { useGetSellerOptionsQuery } = sellerOptionsApi;

interface SellerOptionsRequest {
  mpId: number;
  quantity: number;
  isManufacturerSponsor: boolean;
  /**
   * The zip to price for. The server reads the shopper's zip from their cookies, so this only keys the cache:
   * offers priced for one zip are never shown for another.
   */
  deliveryZipCode: string | null;
}
